export default {
    header: {
        text:"Header",
        color: "#334756",
        default: "#334756"
    },
    leftBtn: {
        text:"Header left button",
        color: "tomato",
        default: "tomato"
    },
    rightBtn: {
        text:"Header right button",
        color: "lime",
        default: "lime"
    },
    path: {
        text:"Path",
        color: "#49FF00",
        default: "#49FF00"
    },
    command: {
        text:"Command",
        color: "white",
        default: "white"
    },
}
